import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss']
})
export class CustomInputComponent implements OnInit {

  @Input() submitted = false;
  @Input() fieldType!: AbstractControl;
  @Input() fieldLabel: string = '';
  @Input() hideLabel = false;
  @Input() fieldId: string = '';
  @Input() errorMessages: Record<string, string> = {};
  @Input() type: string = 'text';
  @Input() placeholder: string = '';
  @Input() mandatory = false;
  @Input() readonly = false;
  @Input() maxlength: string = '255';
  @Input() rows: number = 2;
  @Input() caps = false;
  @Input() disabled = false;


  @Output() blur = new EventEmitter<Event>();

  errorFieldId = '';

  constructor() { }

  ngOnInit(): void {
    this.errorFieldId = `${this.fieldId}-error`;
  }

  showErrorOnFieldHover(): void {
    const element = document.getElementById(this.errorFieldId);
    if (element && !element.classList.contains('show-error')) {
      element.classList.add('show-error');
    }
  }

  hideErrorOnFieldHoverOut(): void {
    const element = document.getElementById(this.errorFieldId);
    if (element) {
      element.classList.remove('show-error');
    }
  }

  changeBlur(event: Event): void {
    if (!this.readonly) {
      this.blur.emit(event);
    }
  }

  handleInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (this.caps) {
      this.fieldType.setValue(input.value.toUpperCase());
    }
  }
}
